import script from "./attributionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./attributionsView.vue?vue&type=script&setup=true&lang=js"

import "./attributionsView.vue?vue&type=style&index=0&id=08e5af8f&scoped=true&lang=css"
import "./attributionsView.vue?vue&type=style&index=1&id=08e5af8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e5af8f"]])

export default __exports__